<template>
  <v-container>
    <v-card style="border: black 1px solid">
      <v-list-item three-line>
        <v-list-item-content>
          <v-list-item-title class="headline mb-1"><span>เพิ่มข้อมูลหลักสูตร</span></v-list-item-title>
          <v-list-item>
            <v-row>
              <v-col
                  cols="12"
                  md="4"
              >
                <div class="d-inline">
                  <v-text-field
                      disabled
                      label="รหัสหลักสูตร" hide-details="auto"
                      v-model="Course_code"
                      counter="8"
                      maxlength="8"
                      hint="ไม่เกิน 8 ตัวอักษร"
                      :rules="[rules.required, rules.counterCourse]"></v-text-field>
                </div>
              </v-col>
              <v-col
                  cols="12"
                  md="5"
              >
                <div class="d-inline">
                  <v-text-field label="ชื่อหลักสูตร" hide-details="auto"
                                :error="Course_name == ''"
                                v-model="Course_name"
                                :rules="[rules.required]"></v-text-field>
                </div>
              </v-col>
              <v-col
                  cols="12"
                  md="3"
              >
                <div class="d-inline">
                  <v-text-field
                      type="number"
                      label="ทำซํ้า (ปี)" hide-details="auto"
                      v-model="Booster"
                      :error="Booster == ''"
                      :rules="[rules.required]"></v-text-field>
                </div>
              </v-col>
            </v-row>
          </v-list-item>
          <v-list-item>
            <v-row>
              <v-col
                  cols="12"
                  md="4"
              >
                <div class="d-inline">
                  <v-autocomplete
                      :items="DepartData"
                      item-text="dep_name"
                      item-value="dep_id"
                      v-model="Dep_model"
                      label="หน่วยงาน"
                      :rules="[rules.required]"
                      required
                  >
                    <template v-slot:item="{item}">
                      <span style="color: darkslategrey">{{ item.dep_name }}</span>
                    </template>
                    <template v-slot:selection="{item}">
                      <span style="color: darkorange">{{ item.dep_name }}</span>
                    </template>
                  </v-autocomplete>
                </div>
              </v-col>
              <v-col
                  cols="12"
                  md="4"
              >
                <div class="d-inline">
                  <v-select
                      :items="CourseGroupData"
                      item-text="Course_group_des"
                      item-value="Course_group"
                      :error="Course_group == ''"
                      v-model="Course_group"
                      label="กลุ่มหลักสูตร"
                      :rules="[rules.required]"
                      required
                  ></v-select>
                </div>
              </v-col>
              <v-col
                  cols="12"
                  md="4"
              >
                <div class="d-inline">
                  <v-select
                      :items="CourseTypeData"
                      item-text="Course_type_des"
                      item-value="Course_type"
                      :error="Course_type == ''"
                      v-model="Course_type"
                      label="สาขาประเภทหลักสูตร"
                      :rules="[rules.required]"
                      required
                  ></v-select>
                </div>
              </v-col>
            </v-row>
          </v-list-item>
          <v-list-item>
            <v-row>
              <v-col
                  cols="4"
              >
                <div class="d-inline">
                  <v-text-field type="number" label="จำนวน ช.ม" hide-details="auto"
                                :error="Course_hour == ''"
                                v-model="Course_hour"
                                :rules="[rules.required]"></v-text-field>
                </div>
              </v-col>
              <v-col
                  cols="4"
              >
                <div class="d-inline">
                  <v-text-field type="number" label="จำนวนเครดิต (ถ้าไม่มีใส่ 0)" hide-details="auto"
                                :error="General_credit == ''"
                                v-model="General_credit"></v-text-field>
                </div>
              </v-col>
              <v-col
                  cols="4"
              >
                <div class="d-inline">
                  <v-select
                      :items="period"
                      item-text="name"
                      item-value="id"
                      :error="Period_code == ''"
                      v-model="Period_code"
                      label="ระยะเวลา"
                      :rules="[rules.required]"
                      required
                  ></v-select>
                </div>
              </v-col>
            </v-row>
          </v-list-item>
          <v-list-item>
            <v-row>
              <v-col
                  cols="12"
              >
                <div class="d-inline">
                  <v-textarea
                      outlined
                      name=""
                      label="รายละเอียดประกอบหลักสูตร"
                      value=""
                      :rules="[rules.required]"
                      v-model="Course_des"
                  ></v-textarea>
                </div>
              </v-col>
            </v-row>
          </v-list-item>
          <v-list-item class="justify-center">
            <v-btn
                large
                color="primary"
                @click="InsertData">เพิ่มข้อมูล
            </v-btn>
          </v-list-item>
        </v-list-item-content>
      </v-list-item>
    </v-card>
  </v-container>
</template>

<script>
import axios from 'axios'
import ConstData from '../../const/Const'
import {mapActions, mapGetters} from 'vuex'
// import {ServiceProvider} from '@/resource'

export default {
  name: "InsertCource",
  data() {
    return {
      CheckAdmin: false,
      Dep_model: '',
      Course_code: '',
      Course_name: '',
      Course_des: '',
      Course_status: '1',
      Course_group: '',
      Course_hour: '0',
      Booster: '',
      General_credit: '0',
      Period_code: '',
      Course_type: '',
      Course: {
        Course_code: '',
        Course_name: '',
        Course_des: '',
        Course_status: '1',
        Course_group: '',
        Course_hour: '0',
        Booster: '',
        General_credit: '0',
        Period_code: '',
        Course_type: '',
        Dep_Code: ''
      },
      rules: {
        required: value => !!value || 'Required.',
        counterCourse: value => value.length <= 8 || 'Max 8 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        },
      },
      Menu: [
        {
          'id': 1,
          'value': 'ข้อมูลหลักสูตร',
          page: '/ManaveCourse/DataCourse'
        },
        {
          'id': 2,
          'value': 'เพิ่มข้อมูลหลักสูตร',
          page: '/ManaveCourse/InsertCourse'
        }],
      period: [
        // {
        //   'name': 'ทั่วไป',
        //   'id': '1'
        // },
        {
          'name': 'ระยะสั้น (ไม่เกิน 1 เดือน)',
          'id': '2'
        },
        {
          'name': 'ระยะยาว (มากกว่า 1 เดือน)',
          'id': '3'
        }
      ],
      status: [
        'ใช้งาน'
        ,
        'ไม่ใช้งาน'
      ],
      CourseGroup: [
        {
          'name': 'ทั่วไป',
          'id': '1'
        },
        {
          'name': 'วิชาชีพ',
          'id': '2'
        },
        {
          'name': 'บริหารจัดการ',
          'id': '3'
        }
      ],
      CourseType: [
        {
          'name': 'ทั่วไป',
          'id': '1'
        },
        {
          'name': 'เฉพาะตำแหน่ง',
          'id': '2'
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      MeData: 'Staff/getMeData',
      DepartData: 'Depart/getDepart',
      CourseGroupData: 'Course/getCourseGroup',
      CourseTypeData: 'Course/getCourseType',
      CourseData: 'Course/getCourse',
      AllDepPermission: 'Permission/getAllDepUserPermission',
      DepPermission: 'Permission/getDepUserPermission',
      PermissionAdmin: 'Permission/getPermission',
      Permission: 'Permission/getPermissionUser',
      Permission_Ms: 'Permission/getPermissionMs',
      Permission_Dep_User: 'Permission/getPermissionDepUser',
      Permission_Dep: 'Permission/getPermissionDep',
      Approve_Ms: 'Permission/getApproveMs',
      Approve: 'Permission/getApprove',
    })
  },
  methods: {
    ...mapActions({
      initMeData: 'Staff/initMeData',
      initDepartData: 'Depart/initDepartData',
      CourseGroupInit: 'Course/initCourseGroupData',
      CourseTypeInit: 'Course/initCourseTypeData',
      initCourseData: 'Course/initCourseData',
      initPermissionDepUserAllData: 'Permission/initPermissionDepUserAllData',
      initPermissionDepUserData: 'Permission/initPermissionDepUserData',
      initPermissionUserData: 'Permission/initPermissionUserData',
      initPermissionMsData: 'Permission/initPermissionMsData',
      getPermissionUserData: 'Permission/getPermissionUserData',
      getPermissionDep: 'Permission/getPermissionDepData',
      initPermissionDepData: 'Permission/initPermissionDepData',
      getPermissionDepUserData: 'Permission/getPermissionDepUserData',
      initApproveMsData: 'Permission/initApproveMsData',
      initApproveData: 'Permission/initApproveData',
      getPermissionData: 'Permission/getPermissionData',
      initPermissionData: 'Permission/initPermissionData',
    }),
    InsertData: function () {
      var CheckInsert = false
      if (this.PermissionAdmin.length > 0) {
        this.PermissionAdmin.map((Per_i, idx) => {
          if (Per_i.permission_id == '2001') {
            CheckInsert = true
            if (this.Course_name == '' || this.Course_des == ''
                || this.Course_status == '' || this.Course_group == '' || this.Course_hour == ''
                || this.Booster == '' || this.Period_code == ''
                || this.Course_type == '' || this.Dep_model == '') {
              this.$swal.fire({
                icon: 'error',
                title: 'พบข้อผิดพลาด',
                text: 'โปรดกรอกข้อมูลให้ครบถ้วน',
              })
            } else {
              this.initCourseData().then(res => {
                if (res) {
                  if (this.CourseData.length == 0) {
                    this.Course.Course_code = this.Course_group + this.Course_type + '001'
                  } else {
                    var Course_id = ''
                    var CheckCourse = false
                    this.CourseData.map(Course_i => {
                      if (Course_i.Course_code.substring(0, 4) == (this.Course_group + this.Course_type)) {
                        Course_id = Course_i.Course_code.substring(5)
                        CheckCourse = true
                      }
                    })
                    if (!CheckCourse) {
                      this.Course.Course_code = this.Course_group + this.Course_type + '001'
                    } else {
                      if ((parseInt(Course_id) + 1) > 10) {
                        this.Course.Course_code = this.Course_group + this.Course_type + '0' + (parseInt(this.CourseData[this.CourseData.length - 1].Course_code.substring(4)) + 1)
                      } else {
                        this.Course.Course_code = this.Course_group + this.Course_type + '00' + (parseInt(this.CourseData[this.CourseData.length - 1].Course_code.substring(4)) + 1)
                      }
                    }
                  }
                  this.Course.Course_name = this.Course_name
                  this.Course.Course_des = this.Course_des
                  this.Course.Course_status = this.Course_status
                  this.Course.Course_group = this.Course_group
                  this.Course.Course_hour = this.Course_hour
                  this.Course.Booster = this.Booster
                  this.Course.General_credit = this.General_credit
                  this.Course.Period_code = this.Period_code
                  this.Course.Course_type = this.Course_type
                  this.Course.Dep_Code = this.Dep_model
                  this.Course.Create_By = this.MeData[0].perid
                  this.Course.Create_Time = 'now()'

                  this.insertData()
                }
              }, reason => {
                if (reason) {
                  this.Course.Course_code = this.Course_group + this.Course_type + '001'

                  this.Course.Course_name = this.Course_name
                  this.Course.Course_des = this.Course_des
                  this.Course.Course_status = this.Course_status
                  this.Course.Course_group = this.Course_group
                  this.Course.Course_hour = this.Course_hour
                  this.Course.Booster = this.Booster
                  this.Course.General_credit = this.General_credit
                  this.Course.Period_code = this.Period_code
                  this.Course.Course_type = this.Course_type
                  this.Course.Dep_Code = this.Dep_model
                  this.Course.Create_By = this.MeData[0].perid
                  this.Course.Create_Time = 'now()'

                  this.insertData()
                }
              })
            }
          } else {
            if (!CheckInsert && idx == this.PermissionAdmin.length - 1) {
              this.$swal.fire({
                icon: 'error',
                title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
              })
            }
          }
        })
      } else {
        this.Permission.map((Per_i, idx) => {
          if (Per_i.permission_id == '2001') {
            CheckInsert = true
            if (this.Course_name == '' || this.Course_des == ''
                || this.Course_status == '' || this.Course_group == '' || this.Course_hour == ''
                || this.Booster == '' || this.Period_code == ''
                || this.Course_type == '' || this.Dep_model == '') {
              this.$swal.fire({
                icon: 'error',
                title: 'พบข้อผิดพลาด',
                text: 'โปรดกรอกข้อมูลให้ครบถ้วน',
              })
            } else {
              this.initCourseData().then(res => {
                if (res) {
                  if (this.CourseData.length == 0) {
                    this.Course.Course_code = this.Course_group + this.Course_type + '001'
                  } else {
                    var Course_id = ''
                    var CheckCourse = false
                    this.CourseData.map(Course_i => {
                      if (Course_i.Course_code.substring(0, 4) == (this.Course_group + this.Course_type)) {
                        Course_id = Course_i.Course_code.substring(5)
                        CheckCourse = true
                      }
                    })
                    if (!CheckCourse) {
                      this.Course.Course_code = this.Course_group + this.Course_type + '001'
                    } else {
                      if ((parseInt(Course_id) + 1) > 10) {
                        this.Course.Course_code = this.Course_group + this.Course_type + '0' + (parseInt(this.CourseData[this.CourseData.length - 1].Course_code.substring(4)) + 1)
                      } else {
                        this.Course.Course_code = this.Course_group + this.Course_type + '00' + (parseInt(this.CourseData[this.CourseData.length - 1].Course_code.substring(4)) + 1)
                      }
                    }
                  }
                  this.Course.Course_name = this.Course_name
                  this.Course.Course_des = this.Course_des
                  this.Course.Course_status = this.Course_status
                  this.Course.Course_group = this.Course_group
                  this.Course.Course_hour = this.Course_hour
                  this.Course.Booster = this.Booster
                  this.Course.General_credit = this.General_credit
                  this.Course.Period_code = this.Period_code
                  this.Course.Course_type = this.Course_type
                  this.Course.Dep_Code = this.Dep_model
                  this.Course.Create_By = this.MeData[0].perid
                  this.Course.Create_Time = 'now()'

                  this.insertData()
                }
              }, reason => {
                if (reason) {
                  this.Course.Course_code = this.Course_group + this.Course_type + '001'

                  this.Course.Course_name = this.Course_name
                  this.Course.Course_des = this.Course_des
                  this.Course.Course_status = this.Course_status
                  this.Course.Course_group = this.Course_group
                  this.Course.Course_hour = this.Course_hour
                  this.Course.Booster = this.Booster
                  this.Course.General_credit = this.General_credit
                  this.Course.Period_code = this.Period_code
                  this.Course.Course_type = this.Course_type
                  this.Course.Dep_Code = this.Dep_model
                  this.Course.Create_By = this.MeData[0].perid
                  this.Course.Create_Time = 'now()'

                  this.insertData()
                }
              })
            }
          } else {
            if (!CheckInsert && idx == this.Permission.length - 1) {
              this.$swal.fire({
                icon: 'error',
                title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
              })
            }
          }
        })
      }

    },
    insertData() {
      var courseDump = ''
      var checkMatch = false
      var stopLoop = false
      var count = 1
      while (count < 999 && !stopLoop) {
        checkMatch = false
        if (count < 10) {
          courseDump = this.Course.Course_code.substring(0, 6) + count
        } else if ((parseInt(this.Course.Course_code.substring(6)) + count) >= 10 && (parseInt(this.Course.Course_code.substring(6)) + count) < 100) {
          courseDump = this.Course.Course_code.substring(0, 5) + count
        } else {
          courseDump = this.Course.Course_code.substring(0, 4) + count
        }
        this.CourseData.map(Course_i => {
          if (Course_i.Course_code.substring(0, 4) == courseDump.substring(0, 4)) {
            if (Course_i.Course_code == courseDump) {
              checkMatch = true
            }
          }
        })
          if (!checkMatch) {
            stopLoop = true
            this.Course.Course_code = courseDump
          } else {
            count++
          }
      }
      const headerAxios = {
        headers: {
          'Content-Type': 'application/json',
          'X-REST-METHOD': 'PUT'
        }
      }
      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_course', this.Course, headerAxios).then(res => {
        if (res.data.status) {
          this.$swal.fire({
            icon: 'success',
            title: 'บันทึกข้อมูลสำเร็จ'
          })
          this.Course_code = ''
          this.Course_name = ''
          this.Course_des = ''
          this.Course_status = '1'
          this.Course_group = ''
          this.Course_hour = ''
          this.Booster = ''
          this.General_credit = ''
          this.Period_code = ''
          this.Course_type = ''
          this.Dep_model = ''
          this.initCourseData()
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'พบข้อผิดพลาด',
            text: 'ไม่สามารถบันทึกข้อมูลได้',
          })
          this.Course_code = ''
          this.Course_name = ''
          this.Course_des = ''
          this.Course_status = '1'
          this.Course_group = ''
          this.Course_hour = ''
          this.Booster = ''
          this.General_credit = ''
          this.Period_code = ''
          this.Course_type = ''
          this.Dep_model = ''
        }
      });
  },
  init() {
    if (this.CourseGroupInit.length == 0) {
      this.CourseGroupInit()
    }
    if (this.CourseTypeInit.length == 0) {
      this.CourseTypeInit()
    }
    if (this.DepartData.length == 0) {
      this.initDepartData().then(res => {
        if (res) {
          this.Dep_model = '35000'
        }
      })
    } else {
      this.Dep_model = '35000'
    }
    if (this.CourseData.length == 0) {
      this.initCourseData()
    }
  }
}
,
mounted()
{
  this.initMeData().then(res => {
    if (res) {
      this.getPermissionData({
        perid: this.MeData[0].perid
      }).then(res => {
        if (res) {
          this.PermissionAdmin.map((Per_i, idx) => {
            if (Per_i.permission_id == '2000') {
              this.CheckAdmin = true
              this.init()
            } else {
              if (!this.CheckAdmin && idx == this.PermissionAdmin.length - 1) {
                this.$router.push('/')
              }
            }
          })
        } else {
          // this.$router.push('/')
          this.getPermissionUserData({
            perid: this.MeData[0].perid
          }).then(res => {
            if (res) {
              this.Permission.map((Per_i, idx) => {
                if (Per_i.permission_id == '2000') {
                  this.CheckAdmin = true
                  this.init()
                } else {
                  if (!this.CheckAdmin && idx == this.Permission.length - 1) {
                    this.$router.push('/')
                  }
                }
              })
            } else {
              this.$router.push('/')
            }
          })
        }
      })
    }
  }).catch(reason => {
    console.log('Reject = ' + reason)
  })
}
}
</script>

<style scoped>
.v-text-field >>> input {
  color: black;
}

.v-text-field >>> label {
  color: black;
  font-weight: bold;
}

.v-text-field >>> button {
  font-size: 0.1em;
}
</style>